import React from 'react'
import ReactDOM from 'react-dom'
import OfferSlider from './OfferSlider'

export const initOfferSlider = () => {
   const offerSliderSettings = {
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      responsive: [
         {
            breakpoint: 992,
            settings: {
               slidesToShow: 2.08,
               dots: false,
            },
         },
      ],
   }

   const initReactSlider = sliderData => {
      ReactDOM.render(
         <OfferSlider {...sliderData} settings={offerSliderSettings} />,
         document.getElementById(sliderData.id),
      )
   }
   document.topOfferSliderIds?.forEach(sliderData => initReactSlider(sliderData))
}